export default __webpack_public_path__ + "static/media/frutela.0e8a47a0.png";